import { render, staticRenderFns } from "./ContractPayrollWizard.vue?vue&type=template&id=08251900&scoped=true"
import script from "./ContractPayrollWizard.vue?vue&type=script&lang=js"
export * from "./ContractPayrollWizard.vue?vue&type=script&lang=js"
import style0 from "./ContractPayrollWizard.vue?vue&type=style&index=0&id=08251900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08251900",
  null
  
)

export default component.exports